import { Routes, Route } from 'react-router-dom'
import { Home } from './pages/Home'
import { Pixelate } from './pages/Pixelate'
import { Create } from './pages/Create'

export function Router() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/pixelate" element={<Pixelate />} />
      <Route path="/create" element={<Create />} />
    </Routes>
  )
}
